"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _themeUi = require("theme-ui");
var _Option = _interopRequireDefault(require("./Option"));
var _reactFeather = require("react-feather");
var _Text = _interopRequireDefault(require("../Input/Text"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/** @jsx jsx */
var Select = function Select(_a) {
  var id = _a.id,
    field = _a.field,
    name = _a.name,
    value = _a.value,
    className = _a.className,
    openIcon = _a.openIcon,
    _b = _a.variant,
    variant = _b === void 0 ? 'select' : _b,
    props = (0, _tslib.__rest)(_a, ["id", "field", "name", "value", "className", "openIcon", "variant"]);
  return (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      position: 'relative',
      flexDirection: 'row'
    }
  }, (0, _themeUi.jsx)(_Text.default, (0, _tslib.__assign)({}, props, {
    as: "select"
  }, field, {
    name: field && field.name || name,
    value: field && field.value || value,
    variant: variant,
    __themeKey: "forms",
    __css: {
      appearance: 'none',
      background: 'none',
      outline: 'none',
      paddingRight: '36px',
      '::-ms-expand': {
        display: 'none'
      },
      '::-ms-value': {
        background: 'white',
        color: 'text'
      },
      ':focus': {
        borderColor: 'primary',
        outline: 'none'
      },
      ':focus::-ms-value': {
        background: 'primary',
        color: 'white'
      }
    }
  })), (0, _themeUi.jsx)(_themeUi.Box, {
    sx: {
      position: 'absolute',
      display: 'inline-block',
      lineHeight: '1',
      top: '50%',
      transform: 'translate(0, -50%)',
      right: '8px',
      pointerEvents: 'none',
      variant: 'forms.select.openIcon'
    },
    variant: "forms." + variant + ".openIcon"
  }, openIcon ? openIcon : (0, _themeUi.jsx)(_reactFeather.ChevronDown, null)));
};
Select.Option = _Option.default;
var _default = Select;
exports.default = _default;